"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsVault__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "depositCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "depositFill",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "DepositCapExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxDeposit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxMint",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxRedeem",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxWithdraw",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawnFailed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "EnumerableMapNonexistentKey",
        type: "error",
    },
    {
        inputs: [],
        name: "InitializedAlready",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidDepositTimeRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "InvalidStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
        ],
        name: "InvalidWithdrawableTime",
        type: "error",
    },
    {
        inputs: [],
        name: "MoveForbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "MovedAlready",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReward",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "NonexistentStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInDepositPeriod",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInWithdrawPeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyFactory",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "SafeERC20FailedOperation",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
            },
        ],
        name: "CoinAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                internalType: "contract IStableCoin",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "coins",
        outputs: [
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "coinsExists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "coinsLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "constructor2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "decimalsOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "depositBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositEndTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositFill",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "emergencyWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hasMoved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositCap",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "maxRedeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "maxWithdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "moveToTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "previewDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "previewMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "previewRedeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "previewWithdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardAsset",
        outputs: [
            {
                internalType: "contract IStableCoin",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositCap",
                type: "uint256",
            },
        ],
        name: "setDepositCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "withdrawableTime",
                type: "uint256",
            },
        ],
        name: "setTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "total",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawableBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SavingsVault__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_factory, overrides) {
        return super.getDeployTransaction(_factory, overrides || {});
    }
    deploy(_factory, overrides) {
        return super.deploy(_factory, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.SavingsVault__factory = SavingsVault__factory;
